<template>
  <div class="spinner" :style="styleObject">
    <div :style="divStyleObject" class="rect1"></div>
    <div :style="divStyleObject" class="rect2"></div>
    <div :style="divStyleObject" class="rect3"></div>
    <div :style="divStyleObject" class="rect4"></div>
    <div :style="divStyleObject" class="rect5"></div>
  </div>
</template>

<script>
export default {
  name: 'Spinner',
  props: {
    marginy: {
      type: Number,
    },
    height: {
      type: Number,
    },
    color: {
      type: String,
      default: '42b983',
    },
  },
  data() {
    return {
      styleObject: {
        margin: `${this.$props.marginy}px auto`,
        height: `${this.$props.height}px`,
      },
      divStyleObject: {
        'background-color': `#${this.$props.color}`,
      },
    };
  },
};
</script>


<style scoped lang="scss">
@import '../assets/css/variables.scss';
.spinner {
  text-align: center;
  margin: 60px auto;
  width: 48px;
  height: 51px;
  @media screen and (min-width: $break-sm) {
    width: 54px;
    height: 61px;
    margin: 200px auto;
  }
}
.spinner > div {
  background-color: #42b983;
  height: 100%;
  width: 6px;
  display: inline-block;

  -webkit-animation: sk-stretchdelay 1.2s infinite ease-in-out;
  animation: sk-stretchdelay 1.2s infinite ease-in-out;
}

.spinner .rect2 {
  -webkit-animation-delay: -1.1s;
  animation-delay: -1.1s;
}

.spinner .rect3 {
  -webkit-animation-delay: -1.0s;
  animation-delay: -1.0s;
}

.spinner .rect4 {
  -webkit-animation-delay: -0.9s;
  animation-delay: -0.9s;
}

.spinner .rect5 {
  -webkit-animation-delay: -0.8s;
  animation-delay: -0.8s;
}

@-webkit-keyframes sk-stretchdelay {
  0%, 40%, 100% { -webkit-transform: scaleY(0.4) }
  20% { -webkit-transform: scaleY(1.0) }
}

@keyframes sk-stretchdelay {
  0%, 40%, 100% {
    transform: scaleY(0.4);
    -webkit-transform: scaleY(0.4);
  }  20% {
    transform: scaleY(1.0);
    -webkit-transform: scaleY(1.0);
  }
}
</style>
